import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';
import assign from 'object-assign';
import qs from 'qs';
import { Glyphicon } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import client from '../../utils/rest/AdminClient';
import DuplicateLocationModal from './duplicate-location-modal';
import { getClassName } from '../../utils/ui/classes';
import { renderMenu } from '../v2/dropdowns/Menu';
class LocationAutosuggest extends Component {
    constructor(props) {
        super(props);
        this.updateItem = (value, item) => {
            value = this.props.searchField === 'name' ? item.name : item.address;
            const duplicateAddress = this.state.suggestions.filter((location) => {
                return location.address === item.address;
            });
            if (duplicateAddress.length > 1) {
                return this.setState({
                    showDuplicateLocationsModal: true,
                    duplicateAddress,
                });
            }
            this.setState({ value }, () => {
                this.props.callbackSelectedItem(item);
            });
        };
        this.updateDuplicate = (item) => {
            const value = this.props.searchField === 'name' ? item.name : item.address;
            this.setState({ value, showDuplicateLocationsModal: false }, () => {
                this.props.callbackSelectedItem(item);
            });
        };
        this.handleHide = () => {
            this.setState({ showDuplicateLocationsModal: false });
        };
        this.renderItem = (item) => {
            const { searchField } = this.props;
            return (React.createElement("a", { id: item.address, className: "list-group-item", style: { cursor: 'pointer' }, key: item.address },
                React.createElement("p", { className: "list-group-item-heading" },
                    item._id !== undefined ? (React.createElement(Glyphicon, { glyph: "star" })) : (React.createElement(Glyphicon, { glyph: "map-marker" })),
                    searchField === 'name' || !searchField ? (React.createElement("span", null,
                        React.createElement("b", null,
                            "\u00A0",
                            item.name,
                            "\u00A0"))) : (React.createElement("span", null,
                        "\u00A0",
                        item.name)),
                    searchField === 'address' ? (React.createElement("span", null,
                        React.createElement("b", null,
                            "\u00A0",
                            item.address))) : (React.createElement("span", null, item.address)))));
        };
        this.renderMenu = (items, _value, style) => {
            const { dropdownStyle } = this.props;
            const defaultStyle = {
                position: 'absolute',
                top: 45,
                left: 0,
                zIndex: 100,
                background: 'white',
            };
            return renderMenu(items, Object.assign(Object.assign(Object.assign(Object.assign({}, style), defaultStyle), this.menuStyle), dropdownStyle));
        };
        this.autocompleteLocationRequest = debounce(autocompleteLocationRequest, 500);
        this.state = {
            value: this.props.value,
            suggestions: [],
            showDuplicateLocationsModal: false,
            duplicateAddress: null,
            searchType: this.props.searchType
                ? this.props.searchType
                : {
                    includeCargomaticAddresses: 1,
                    includeGoogleAddresses: 1,
                },
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            const { value } = nextProps;
            this.setState({ value });
        }
    }
    render() {
        const { searchField, t } = this.props;
        return (React.createElement("div", { className: "relative flex-1 w-full" },
            React.createElement(Autocomplete, { inputProps: {
                    id: this.props.id,
                    className: getClassName('w-full form-field', this.props.className),
                    style: this.props.inputStyle || { width: '100%' },
                    placeholder: t(this.props.placeholderText),
                    readOnly: this.props.readOnly,
                }, wrapperStyle: {}, autoHighlight: this.props.autoHighlight, value: this.state.value || '', items: this.state.suggestions, getItemValue: (item) => item.name, onSelect: (value, item) => this.updateItem(value, item), onChange: (event, value) => {
                    this.setState({ value });
                    clearTimeout(this.timeout);
                    if (this.props.onChange) {
                        this.props.onChange(value);
                    }
                    this.timeout = setTimeout(() => {
                        if (!value) {
                            this.setState({ suggestions: [] });
                            return;
                        }
                        this.autocompleteLocationRequest(value, searchField, this.state.searchType, (suggestions) => {
                            if (suggestions) {
                                this.setState({ suggestions });
                            }
                        });
                    }, 500);
                }, menuStyle: {
                    borderRadius: '3px',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                    background: 'rgba(255, 255, 255, 0.9)',
                    padding: '2px 0',
                    fontSize: '90%',
                    position: 'fixed',
                    overflow: 'auto',
                    maxHeight: '50%',
                    zIndex: 1,
                }, renderMenu: this.renderMenu, renderItem: this.renderItem }),
            React.createElement("div", null, this.state.showDuplicateLocationsModal && (React.createElement(DuplicateLocationModal, { onHide: this.handleHide, show: this.state.showDuplicateLocationsModal, addresses: this.state.duplicateAddress, onSelectLocation: this.updateDuplicate })))));
    }
}
LocationAutosuggest.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    inputStyle: PropTypes.object,
    placeholderText: PropTypes.string,
    searchField: PropTypes.string,
    callbackSelectedItem: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    searchType: PropTypes.object,
    readOnly: PropTypes.bool,
    autoHighlight: PropTypes.bool,
};
LocationAutosuggest.defaultProps = {
    value: '',
    placeholderText: 'START_TYPING_TO_SEARCH_FOR_A_LOCATION',
    autoHighlight: true,
};
function autocompleteLocationRequest(value, field, searchType, cb) {
    getLocationSuggestions(value, field, searchType).then((res) => {
        cb(res.entity.filter((l) => l.address));
    });
}
function getLocationSuggestions(value, field, searchType) {
    const path = '/api/v2/locations/autocomplete';
    const params = {
        input: value,
    };
    if (field !== '') {
        params.only = field;
    }
    const queryParams = assign({}, {
        input: value,
        includeGoogleAddresses: searchType.includeGoogleAddresses,
        includeCargomaticAddresses: searchType.includeCargomaticAddresses,
    }, params || {});
    const queryString = qs.stringify(queryParams);
    return client({
        method: 'GET',
        path: `${path}?${queryString}`,
    });
}
export default withTranslation()(LocationAutosuggest);
